import globalLogicService from "./globalLogicService";
import moment from "moment";

const validationsService = {};

// ____________________________________________________
validationsService.validateAnyValue = valueToCheck =>
  valueToCheck !== null &&
  valueToCheck !== 0 &&
  valueToCheck !== "" &&
  valueToCheck !== undefined &&
  valueToCheck !== false;

// ____________________________________________________
// Check That Field is not empty function
validationsService.checkFieldNotEmpty = fieldVal =>
  fieldVal !== "" && fieldVal !== undefined && fieldVal !== null;

// ____________________________________________________
// Check That Field is not empty function minimum of 3 characters
validationsService.checkFieldNotEmptyAndMin3Characters = fieldVal =>
  fieldVal !== "" &&
  fieldVal !== undefined &&
  fieldVal.length > 2 &&
  fieldVal !== null;

// ____________________________________________________
// Check That Field is not empty function minimum of 8 characters
validationsService.checkFieldNotEmptyAndMin8Characters = fieldVal =>
  fieldVal !== "" &&
  fieldVal !== undefined &&
  fieldVal.length > 7 &&
  fieldVal !== null;

// ____________________________________________________
// Tax Rate Cap
validationsService.taxRateCap = arg => {
  let argReadyForCapCheck = false;

  if (validationsService.isInteger(arg)) {
    console.log("Found an integer.");
    argReadyForCapCheck = true;
  } else if (validationsService.isFloat(arg)) {
    console.log("Found a float number.");
    argReadyForCapCheck = true;
  } else {
    console.log("Could not determine what this thing is...");
    return false;
  }

  return argReadyForCapCheck === true && arg < 15;
};

// ____________________________________________________
// Check that an email address is valid
validationsService.emailRegex = fieldVal => {
  // const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(fieldVal);
};

validationsService.checkValidEmail = fieldVal =>
  !!(
    validationsService.checkFieldNotEmpty(fieldVal) &&
    validationsService.emailRegex(fieldVal) !== false
  );

// ____________________________________________________
// Check to see if number is an integer
validationsService.isInteger = x =>
  typeof x === "number" && isFinite(x) && Math.floor(x) === x;

// ____________________________________________________
// Check to see if number is a floating point.
validationsService.isFloat = x => !!(x % 1);

// ____________________________________________________
// Phone number regex function
validationsService.phoneNumberRegex = fieldVal => {
  const re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return re.test(fieldVal);
};

// Validate that 10 digit phone number is true
validationsService.checkValidPhoneNumber = fieldVal =>
  validationsService.phoneNumberRegex(fieldVal) !== false &&
  fieldVal !== "" &&
  fieldVal !== undefined &&
  fieldVal !== null;

// ____________________________________________________
// Validate that field is a number integer
validationsService.checkNumberValue = fieldVal => {
  const newValNum = Number(fieldVal);
  return !!(
    validationsService.isInteger(newValNum) &&
    !isNaN(newValNum) &&
    // (newValNum !== NaN) &&
    newValNum !== undefined &&
    newValNum !== null
  );
};

// ____________________________________________________
validationsService.deepNumberValueCheck = fieldVal => {
  let newValNum;
  if (
    validationsService.isFloat(fieldVal) ||
    validationsService.isInteger(fieldVal)
  ) {
    newValNum = fieldVal;
  } else {
    newValNum = Number(fieldVal);
  }

  return (
    !isNaN(newValNum) &&
    newValNum !== 0 &&
    newValNum !== undefined &&
    newValNum !== null
  );
};

// ____________________________________________________
validationsService.checkCCNumber = fieldVal => {
  const newValNum = Number(fieldVal);
  return !!(
    validationsService.isInteger(newValNum) &&
    !isNaN(newValNum) &&
    newValNum !== undefined &&
    String(newValNum).length === 16 &&
    newValNum !== null
  );
};

// ____________________________________________________
validationsService.checkCVCNumber = fieldVal => {
  const newValNum = Number(fieldVal);
  return !!(
    validationsService.isInteger(newValNum) &&
    !isNaN(newValNum) &&
    newValNum !== undefined &&
    String(newValNum).length === 3 &&
    newValNum !== null
  );
};

// ____________________________________________________
validationsService.checkCCMonth = fieldVal => {
  const newValNum = Number(fieldVal);
  return !!(
    validationsService.isInteger(newValNum) &&
    !isNaN(newValNum) &&
    newValNum !== undefined &&
    String(newValNum).length === 2 &&
    newValNum !== null
  );
};

// ____________________________________________________
validationsService.checkCCYear = fieldVal => {
  const newValNum = Number(fieldVal);
  return !!(
    validationsService.isInteger(newValNum) &&
    !isNaN(newValNum) &&
    newValNum !== undefined &&
    String(newValNum).length === 4 &&
    newValNum !== null
  );
};

// ____________________________________________________
// Check if date is today or in the future (time is ignored)
validationsService.checkDateNotInThePast = fieldVal => {
  let newValDate = moment(fieldVal, "MM/DD/YYYY h:mm A");
  if (!newValDate.isValid()) {
    newValDate = moment(fieldVal);
  }
  return !!(newValDate.isValid() && moment().diff(newValDate, "days") <= 0);
};

// ____________________________________________________
// Check if date is today or in the future (time is ignored)
validationsService.checkFirstDateIsFirst = (val1, val2) => {
  let newValDate1 = moment(val1, "MM/DD/YYYY h:mm A");
  let newValDate2 = moment(val2, "MM/DD/YYYY h:mm A");
  if (!newValDate1.isValid()) {
    newValDate1 = moment(val1);
  }
  if (!newValDate2.isValid()) {
    newValDate2 = moment(val2);
  }
  return !!(
    newValDate1.isValid() &&
    newValDate2.isValid() &&
    newValDate1.diff(newValDate2, "minutes") <= 0
  );
};

// ____________________________________________________
// Check Zip Code String Length
validationsService.checkZipCode = fieldVal =>
  /^\s*\d{5}\s*$/.test(fieldVal) !== false &&
  fieldVal !== "" &&
  fieldVal !== undefined &&
  fieldVal !== null;

// ____________________________________________________
// Check that Password fields are identical, match values and length
validationsService.identicalPasswords = (fieldVal, fieldValMatch) => {
  const checkPasswordLength = valToCheck => valToCheck.length >= 8;

  if (fieldVal === fieldValMatch) {
    if (
      validationsService.checkFieldNotEmpty(fieldVal) &&
      checkPasswordLength(fieldVal)
    ) {
      return true;
    }
  } else {
    return false;
  }
};

// ____________________________________________________
// Global methods you have access to:
globalLogicService.addNumbersForTheHellOfIt = (a, b) => a + b;

// ____________________________________________________
// Check to see if number is an integer
globalLogicService.isInteger = x =>
  typeof x === "number" && isFinite(x) && Math.floor(x) === x;

// ____________________________________________________
// Check to see if number is a floating point.
globalLogicService.isFloat = x => !!(x % 1);

// ____________________________________________________
// Set Dollar Value
globalLogicService.setADollarValue = argValue => {
  let donationDollarAmount = argValue;
  if (argValue !== "" && argValue !== undefined) {
    return donationDollarAmount;
  }
  donationDollarAmount = "0";
  return donationDollarAmount;
};

// ____________________________________________________
// Check to see if a number is a float and if so then sanitize it
// If not then
globalLogicService.sanitizeFloatNumber = rawValue => {
  const numberValue = Number(rawValue);

  if (this.isFloat(numberValue)) {
    const string_1Num = `${String(numberValue)}0`;
    const num_1_change = parseFloat(string_1Num);

    return Number(num_1_change.toFixed(2));
  }
  if (this.isInteger(numberValue)) {
    return numberValue;
  }
};

// ____________________________________________________
// Check character length.
globalLogicService.checkCharacterLength = (arg, min, max) => {
  // Turn the arg into a string
  const stringArg = String(arg);
  const minArg = Number(min);
  const maxArg = Number(max);
  let minValue = false;
  let maxValue = false;

  // Check that the arg meets the minimum value length
  if (stringArg.length >= minArg) {
    minValue = true;
  }

  // Check that the arg is within the maximum value length
  if (stringArg.length <= maxArg) {
    maxValue = true;
  }

  return minValue === true && maxValue === true;
};

// ____________________________________________________
globalLogicService.trimStringLength = args => {
  const trimmedString = args.string.substring(0, args.length);

  return args.string.length > 45 ? `${trimmedString}...` : `${trimmedString}`;
};

// ____________________________________________________

export default validationsService;
